import { useEffect, useState } from "react";
import axios from "axios";
import { esAgenteBiwo } from "./agentesBiwo";

const SIN_ACCESO = { puede: false, puedeRevisar: false };

let cache = { usuarioId: null, promesa: null };

export const consultarAccesoSoporte = ({ tipo, usuarioId, headersToken, forzar = false }) => {
  if (esAgenteBiwo(usuarioId)) return Promise.resolve({ puede: true, puedeRevisar: false });
  if (tipo === 0) return Promise.resolve({ puede: true, puedeRevisar: true });

  if (!forzar && cache.usuarioId === String(usuarioId) && cache.promesa) return cache.promesa;

  const promesa = axios
    .post("soporte/puedoReportar", {}, { headers: headersToken })
    .then((res) =>
      res.data.success === 2 ? { puede: !!res.data.puede, puedeRevisar: !!res.data.puedeRevisar } : SIN_ACCESO,
    )
    .catch(() => {
      cache = { usuarioId: null, promesa: null };
      return SIN_ACCESO;
    });

  cache = { usuarioId: String(usuarioId), promesa };
  return promesa;
};

export const useAccesoSoporte = ({ tipo, usuarioId, headersToken }) => {
  const [acceso, setAcceso] = useState(SIN_ACCESO);

  useEffect(() => {
    let vigente = true;
    consultarAccesoSoporte({ tipo, usuarioId, headersToken }).then((r) => vigente && setAcceso(r));
    return () => {
      vigente = false;
    };
  }, [tipo, usuarioId, headersToken]);

  return acceso;
};

export default consultarAccesoSoporte;
